import React from 'react';
import './LoadingSpinner.css';

export default function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="spinner-ring"></div>
      <div className="spinner-core"></div>
    </div>
  );
}
